/**
 * Описания и градации рангов иерархии (строго с шагом в 10 единиц)
 */
export const HIERARCHY_STEPS = [
  { level: 100, title: 'Супер-администратор', category: 'Главный Администратор (Абсолютный доступ)', color: '#dc2626' },
  { level: 90, title: 'Зам. Главного Администратора', category: 'Высшее руководство системы', color: '#ea580c' },
  { level: 80, title: 'Администратор системы', category: 'Администраторы офиса и конфигураторы', color: '#d97706' },
  { level: 70, title: 'Старший менеджер / Аудитор', category: 'Контроль и аудит филиалов', color: '#0284c7' },
  { level: 60, title: 'Модератор / Региональный управляющий', category: 'Управление группами пользователей', color: '#2563eb' },
  { level: 50, title: 'Аудитор / Служба безопасности', category: 'Мониторинг и аналитика', color: '#4f46e5' },
  { level: 40, title: 'Специалист коммерческого/торгового отдела', category: 'Отраслевые операторы (КМ, ТО)', color: '#7c3aed' },
  { level: 30, title: 'Справочная служба / Диспетчер', category: 'Информационная поддержка', color: '#9333ea' },
  { level: 20, title: 'Центральный склад / Логистика', category: 'Складские и логистические учетные записи', color: '#059669' },
  { level: 10, title: 'Аптека / Точка продаж (POS)', category: 'Конечные рабочие места фармацевтов', color: '#475569' }
];

export function getHierarchyInfo(level: number) {
  const rounded = Math.max(10, Math.min(100, Math.round(level / 10) * 10));
  return HIERARCHY_STEPS.find(s => s.level === rounded) || {
    level: rounded,
    title: `Ранг ${rounded}`,
    category: 'Пользовательская роль',
    color: '#64748b'
  };
}
